module.exports = __webpack_public_path__ + "../resources/images/SkyCode_48-641bce0b1598db3940c24ac54582f729.svg";